import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { SharedServiceService } from 'app/services/shared-service.service';
import { DepoitsService } from 'app/components/deposits/depoits.service';

declare var jQuery: any;
@Component({
  selector: 'app-destination-sheba',
  templateUrl: './destination-sheba.component.html',
  styleUrls: ['./destination-sheba.component.scss']
})
export class DestinationShebaComponent implements OnInit, OnChanges {
  selectedIban;
  savedIbans = [];
  @Input() hasError;
  @Input() hideList = false;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  @Input() optional = false;
  isValid = true;
  @Input() title = 'شبا مقصد';
  @Input() getIban;
  @Input() onlyNovin = false;
  constructor(private sharedService: SharedServiceService, private depositService: DepoitsService) { }
  ngOnChanges(): void {
    if (this.savedIbans !== null && this.savedIbans.length > 0) {
      if (this.getIban === '') {
        this.selectedIban = '';
      }
    }
  }

  ngOnInit(): void {
    this.savedIbans = JSON.parse(sessionStorage.getItem('destinationIbans'));
    if (this.savedIbans === null) {
      this.getDestinationIbans();
    } else {
      if (this.onlyNovin === true) {
        this.savedIbans = this.savedIbans.filter(x=>x.bank === 'eghtesadnovin');
      }
    }
    if (this.getIban !== undefined && this.getIban !== '') {
      const iban = this.getIban.iban;
      this.selectedIban = this.getIban.iban.substring(2);
      this.notifyParent.emit(iban);
    }
  }
  getDestinationIbans() {
    this.depositService.getDestinationIbans().subscribe(
      res => {
        if (res.code === 0) {
          this.savedIbans = res.content;
          sessionStorage.setItem('destinationIbans', JSON.stringify(res.content));
          if (this.onlyNovin === true) {
            this.savedIbans = this.savedIbans.filter(x=>x.bank === 'eghtesadnovin');
          }
        }
      }
    );
  }
  sendParentNotification(index) {
    this.isValid = true;
    const temp = this.savedIbans[index].iban.substring(2);
    this.selectedIban = temp;
    const selectedIban = { ...this.savedIbans[index] };
    this.notifyParent.emit(selectedIban);
    jQuery('#ibans').modal('hide');
  }
  // 050620000000301325735001
  ibanPattern(event) {
    this.isValid = true;
    if (event.key === 'Backspace') {
    } else {
      if (this.selectedIban.length === 24) {
        this.checkIbanValidation();
      }
    }
  }
  checkIbanValidation() {
    if (this.selectedIban.toLowerCase().includes('ir')) {
      this.selectedIban = this.selectedIban.toString().substr(2);
    }
    this.selectedIban = this.sharedService.convertToEnglishNumber(this.selectedIban);
    const temp = 'IR' + this.selectedIban;
    this.isValid = this.isValidIBANNumber(temp);
    if (this.isValid) {
      this.notifyParent.emit(temp);
    }
    jQuery('#selectedIban').blur();
  }
  sendIban() {
    if (this.optional) {
      this.isValid = true;
      if (this.selectedIban === undefined) {
        this.selectedIban = '';
        this.notifyParent.emit(this.selectedIban);
        return;
      }
    }
    if (this.selectedIban !== undefined && this.selectedIban !== '') {
      this.checkIbanValidation();
      // if (this.isValid) {
      //   this.notifyParent.emit(this.selectedIban);
      // }
    }
  }
  isValidIBANNumber(control) {
    const codeLengths = {
      AD: 24, AE: 23, AL: 28, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29, CH: 21, CR: 21, CY: 28, CZ: 24,
      DE: 22, DK: 18, DO: 28, EE: 20, ES: 24, LC: 30, FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28,
      HR: 21, HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28, LI: 21, LT: 20, LU: 20, LV: 21,
      MC: 27, MD: 24, ME: 22, MK: 19, MR: 27, MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
      RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26, IR: 26
    };
    if (control) {
      const iban = control.toUpperCase().replace(/[^A-Z0-9]/g, '');
      const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
      let digits: number;
      if (!code || iban.length !== codeLengths[code[1]]) {
        return false;
      }
      digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (letter: string) => {
        return letter.charCodeAt(0) - 55;
      });
      return this.mod97(digits) === 1 ? true : false;
    }
  }
  private mod97(digital: number | string) {
    digital = digital.toString();
    let checksum: number | string = digital.slice(0, 2);
    let fragment = '';
    for (let offset = 2; offset < digital.length; offset += 7) {
      fragment = checksum + digital.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
  }
  focusInput(event) {
    if (event.currentTarget.value !== '') {
      const val = event.currentTarget.value;
      event.currentTarget.setSelectionRange(0, 0);
      event.currentTarget.selectionStart = event.currentTarget.value.length;
      event.currentTarget.selectionEnd = event.currentTarget.value.length;
    }
  }

}
